import React from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons/faChevronLeft";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons/faChevronRight";

const PageNav = ({
  previousPage,
  nextPage,
  gotoPage,
  pageCount,
  pageIndex,
  canNextPage,
  canPreviousPage,
  pageOptions,
}) => {
  return (
    <div className="panel__page-nav-container">
      <div className="panel__page-nav">
        <div className="panel__page-nav-buttons-container">
          <button
            type="button"
            onClick={() => gotoPage(0)}
            disabled={!canPreviousPage}
            className="panel__page-nav-button"
          >
            <FontAwesomeIcon icon={faChevronLeft} />
            <FontAwesomeIcon icon={faChevronLeft} />
          </button>
          <button
            type="button"
            onClick={() => previousPage()}
            disabled={!canPreviousPage}
            className="panel__page-nav-button"
          >
            <FontAwesomeIcon icon={faChevronLeft} />
          </button>
        </div>
        <div className="panel__page-nav-number-container">
          Page{" "}
          <span className="emphasis">
            {pageIndex + 1} of {pageOptions.length}
          </span>
        </div>
        <div className="panel__page-nav-buttons-container">
          <button
            type="button"
            onClick={() => nextPage()}
            disabled={!canNextPage}
            className="panel__page-nav-button"
          >
            <FontAwesomeIcon icon={faChevronRight} />
          </button>
          <button
            type="button"
            onClick={() => gotoPage(pageCount - 1)}
            disabled={!canNextPage}
            className="panel__page-nav-button"
          >
            <FontAwesomeIcon icon={faChevronRight} />
            <FontAwesomeIcon icon={faChevronRight} />
          </button>
        </div>
      </div>
    </div>
  );
};

PageNav.propTypes = {
  previousPage: PropTypes.func.isRequired,
  nextPage: PropTypes.func.isRequired,
  gotoPage: PropTypes.func.isRequired,
  pageCount: PropTypes.number.isRequired,
  pageIndex: PropTypes.number.isRequired,
  canNextPage: PropTypes.bool.isRequired,
  canPreviousPage: PropTypes.bool.isRequired,
  pageOptions: PropTypes.arrayOf(PropTypes.any).isRequired,
};

export default PageNav;
